import { Fragment, useEffect, useState } from "react";

import { ProductHybridFilter } from "./HybridFilter/productHybridFilter";
import { ProductImageGallery } from "./productImageGallery";
import { OtherActivity } from "./RightOptions/otherDetails";
import { FamilyDescriptionContainer } from "./family/familyDescriptionContainer";
import { HybridMainTitle } from "./hybridMainTitle";
import { axiosInstance } from "../../axios/axiosInstance";
import { ProductPageDescription } from "./ProductDescription/productPageDescription";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { ConvertToFloat } from "../../Layout/Common/common";
import { DescriptionContainer, hasAnyDetails } from "./ProductDescription/descriptionContainer";
import { SeeAllProductButton, ViewAllProductButton } from "./family/rightSideUtilityButton";
import { ProductStockStatusContainer } from "../../Layout/Common/productStockStatusContainer";
import { useAuth } from "../../Context/AuthContext";
import { PriceTableContainer } from "./priceTableContainer";
import Skeleton from "react-loading-skeleton";
import { HybridDownloadContainer } from "./downloadContainer/hybridDownloadContainer";
import { AskQuestionContainer } from "./askQuestionContainer";

export const ProductDetailsContainer = ({ params, stock, setIshybrid, hybridData, familyProducts }) => {
  const [pageData, setPageData] = useState(params?.familyDetails ? params : null);
  const [familyData, setFamilyData] = useState(params?.familyDetails ?? null);
  const [productId, setProductId] = useState(null);
  const [productCode, setProductCode] = useState(null);
  const [subHeading, setSubHeading] = useState(null);
  const [stockStatus, setStockStatus] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [productPrice, setProductPrice] = useState(params?.familyDetails?.productPrice ?? null);
  const [isHybridFilter, setIsHybridFilter] = useState(false);
  const [hasPriceTable, setHasPriceTable] = useState(true);
  const [productIdUnbxd, setProductIdUnbxd] = useState(params?.familyDetails?.productId ?? null);
  const isPreview = pageData?.isPreview === true;
  const { getProductPrice } = useGlobalFunction();
  const handleOnFilterChange = (item) => {
    setSubHeading(item.subHeading ?? "");
  };
  const { userId, eBayBlock } = useAuth();
  const [iseBayBlock, setiseBayBlock] = useState(false);

  useEffect(() => {
    if (stock) {
      setStockStatus(stock);
    }
  }, [stock]);

  useEffect(() => {
    if (params) {
      setPageData(params);
      setiseBayBlock(params.familyDetails.iseBayBlock);
      if (params.familyDetails) {
        setFamilyData(params.familyDetails);
        setProductIdUnbxd(params.familyDetails.productId ?? 0);
        setProductCode(params.familyDetails.productCode ?? "");
        setProductPrice(params.familyDetails.productPrice ?? (params.isPreview ? null : 0));
        if (!params.isPreview) fetchProductPrice(params.familyDetails.productId);
        if (hybridData && hybridData.listAttribute) {
          setIsHybridFilter(true);
          setIshybrid(true);
          const disnictedAttrData = hybridData.listAttribute.map((item) => {
            const uniqueAttrData = [
              ...item.attrData
                .reduce((map, { sku, selected, ...rest }) => {
                  const key = String(rest.filterString);

                  if (!map.has(key)) {
                    map.set(key, { ...rest, selected });
                  } else {
                    const existing = map.get(key);
                    if (selected) existing.selected = 1;
                    if (rest.disabled != 2) existing.disabled = rest.disabled;
                  }

                  return map;
                }, new Map())
                .values(),
            ];

            return {
              attrName: item.attrName,
              attrData: uniqueAttrData,
            };
          });

          let attrfilter = disnictedAttrData.filter((item) => item.attrName != "Colour");

          let colorFilter = disnictedAttrData.find((item) => item.attrName == "Colour");

          const selectedValues = hybridData.listAttribute.reduce((acc, attr) => {
            const selectedItem = attr.attrData.find((item) => item.selected == 1);
            if (selectedItem) {
              acc[attr.attrName] = selectedItem.filterString;
            }
            return acc;
          }, {});
          try {
            const selectedHeading = Object.entries(selectedValues)
              .map(([key, value]) => ` ${key}: ${value}`)
              .join(", ")
              .trim();

            handleOnFilterChange({
              subHeading: selectedHeading,
            });
          } catch (e) {}
          setFilterData({
            attrFilter: attrfilter,
            colorFilter: colorFilter,
            selectedValue: selectedValues,
            filterRawData: hybridData.listAttribute,
          });
        } else {
          setIsHybridFilter(false);
          setIshybrid(false);
        }
      }
    }
  }, [params, hybridData]);

  const fetchProductPrice = async (productId) => {
    let price = await getProductPrice(productId ?? 0);
    if (price) setProductPrice(ConvertToFloat(price));
  };

  return (
    <Fragment>
      {pageData && (
        <section className="product-section" data-id={productIdUnbxd}>
          <div className="container-fluid container-lg">
            <div className="row">
              <div className="col-lg-12">
                <div className="productsDetail-gallery">
                  <ProductImageGallery params={pageData.imageList} />
                  <div className="productsDetail-rht" style={{ maxWidth: "770px" }}>
                    <HybridMainTitle params={familyData} subHeading={subHeading} stockStatus={stockStatus} />
                    {isHybridFilter === true && <ProductHybridFilter params={filterData} pageData={familyData} />}
                    {familyData.isFamily == false ? (
                      <Fragment>
                        <div className="proPricing-details mt-4">
                          <div className="pricing-details-wrapper d-lg-flex">
                            <div className="price-info-left" style={hasPriceTable ? undefined : { border: 0 }}>
                              {productPrice == null ? (
                                <Skeleton width={160} height={32} />
                              ) : (
                                <h2 className="fw-bold">
                                  $ {ConvertToFloat(productPrice)} <small className="fs-13 fw-normal">ex GST</small>
                                </h2>
                              )}
                              <div className="product-stock d-sm-flex d-lg-block">
                                <div className="pro-code">Code: {familyData.sku?.toUpperCase()}</div>
                                <div className="pro-availablity d-inline-flex">
                                  <span className="me-1">
                                    Availability:
                                    {stockStatus ? (
                                      eBayBlock && iseBayBlock ? (
                                        " UNAVAILABLE "
                                      ) : (
                                        <ProductStockStatusContainer
                                          params={stockStatus}
                                          stockStatus={stockStatus?.stockStatus}
                                          isPlainText={true}
                                        />
                                      )
                                    ) : (
                                      <Skeleton width={100} height={16} />
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <PriceTableContainer
                              productId={familyData.productId}
                              productCode={familyData.sku}
                              onHasPrices={setHasPriceTable}
                            />
                          </div>
                          {stockStatus &&
                            stockStatus.stockStatusRaw.includes("DISCONTINUED") == false &&
                            stockStatus.stockStatusRaw.includes("TEMPORARY UNAVAILABLE NO ETA") == false &&
                            stockStatus.isSubstitute === false && (
                              <OtherActivity
                                params={familyData}
                                isBuyable={stockStatus ? stockStatus.isShowBuy : true}
                              />
                            )}
                          {isHybridFilter === true && <SeeAllProductButton />}
                        </div>
                        <DescriptionContainer params={pageData.familyDetails} />
                      </Fragment>
                    ) : (
                      <Fragment>
                        <DescriptionContainer params={pageData.familyDetails} />
                      </Fragment>
                    )}

                    {isPreview ? (
                      <div className="mb-20px" id="section-downloads">
                        <div className="proSection-title custom-border">
                          <h4 className="d-flex align-items-start justify-content-between">
                            Downloads <i className="fa-solid fa-chevron-down" />
                          </h4>
                        </div>
                      </div>
                    ) : (
                      <HybridDownloadContainer params={familyData} />
                    )}
                    <AskQuestionContainer familyData={familyData} />
                    {familyData.isFamily !== false && hasAnyDetails(pageData.familyDetails) && <ViewAllProductButton />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
};
